import AptitudeTestChoice from 'src/entities/AptitudeTestChoice';

export default class AptitudeTestQuestion {
  id: number;
  statement: string;
  choices: Array<AptitudeTestChoice>;

  constructor(entity: AptitudeTestQuestion) {
    this.id = entity.id;
    this.statement = entity.statement;
    this.choices = entity.choices ?
      entity.choices.map(choice => new AptitudeTestChoice(choice)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/entities/AptitudeTestQuestion.tsx